<section class="h-fit w-full md:w-[40dvh] rounded-2xl bg-white mx-auto">
  <div class="flex items-center justify-between p-4 py-3">
    <div class="flex items-center gap-2">
      <app-icon name="lucide:baby" class="text-primary" />
      <p class="font-medium text-gray-800">아동선택</p>
    </div>
    <app-button variant="ghost" color="gray" (click)="close($event)"
      >닫기</app-button
    >
  </div>
  <div class="flex flex-col gap-4 size-full p-4">
    <div class="flex flex-col gap-3 overflow-y-scroll max-h-[15rem]">
      @for (child of childStore.children(); track $index) {
        <button
          class="box-content flex gap-3 items-center p-2 transition-all duration-300 border-2 rounded-lg"
          [ngClass]="
            childStore.selectedChild$()?.id === child.id
              ? 'bg-gray-50 border-primary'
              : 'border-white'
          "
          (click)="selectChild(child, $event)"
        >
          <p class="text-sm text-gray-800 min-w-max">
            {{ child.name }}
          </p>
          <div class="flex gap-3 items-center">
            <p class="text-sm text-gray-400">
              {{ Gender[child.gender] }}
            </p>
            <div class="bg-gray-200 w-px h-3"></div>
            <p class="text-sm text-gray-400 min-w-max">
              {{ child.birth | date: 'yyyy.MM.dd' }} 일생
            </p>
            @if (child.relationship) {
              <div class="bg-gray-200 w-px h-3"></div>
              <p class="text-sm text-gray-400 min-w-max">
                {{ Relationship[child.relationship] }}
              </p>
            }
          </div>
          @if (childStore.selectedChild$()?.id === child.id) {
            <div class="flex items-center justify-end w-full">
              <app-icon
                name="material-symbols:check-rounded"
                class="text-primary"
                size="sm"
              />
            </div>
          } @else {
            <div class="size-px"></div>
          }
        </button>
      }
    </div>
  </div>
  <div class="flex items-center gap-3 justify-center p-4">
    <button
      (click)="moveToPage('/find/create', $event)"
      class="hover:oapacity-80 transition-all flex items-center gap-1 text-gray-400"
    >
      <app-icon name="material-symbols:add" class="size-5" />
      <p class="text-sm">아동 등록</p>
    </button>

    <div class="h-4 w-px bg-gray-200"></div>

    <button
      (click)="moveToPage('/find/find-child', $event)"
      class="hover:oapacity-80 transition-all flex items-center gap-1 text-gray-400"
    >
      <app-icon name="ic:baseline-search" class="size-5" />
      <p class="text-sm">아동 찾기</p>
    </button>
  </div>
</section>
